import HOM_IMAGES from './constants/integrations/Hom';

function getRandomInt(max: any) {
  return Math.floor(Math.random() * Math.floor(max));
}

export default function () {
  return HOM_IMAGES[getRandomInt(HOM_IMAGES.length - 1)];
}
